const minScrollDown = () => {
  return 30
}
const minScrollUp = () => {
  var relativeHeight = window.innerHeight / 2
  return relativeHeight > 300 ? 300 : relativeHeight
}

let scrollTracker = {
  isScrollUp: false,
  position_lastScroll: 0,
  position_lastDirectionChange: 0,
  Update: function (scrollPosition) {
    var update_isScrollUp = scrollPosition < this.position_lastScroll
    if (update_isScrollUp != this.isScrollUp) {
      this.isScrollUp = update_isScrollUp
      this.position_lastDirectionChange = scrollPosition
    }
    this.position_lastScroll = scrollPosition
  },
  ScrollDistance: function () {
    return Math.abs(this.position_lastScroll - this.position_lastDirectionChange)
  },
}

let StickyHeaderElement = {
  usable: false,
  init: function (querySelectorElement, querySelectorTarget = null) {
    this.element = document.querySelector(querySelectorElement)
    if (!this.element) return

    if (querySelectorTarget) {
      this.target = document.querySelector(querySelectorTarget)
      if (!this.target) {
        console.log("target not found")
        this.target = this.element
      }
    } else {
      this.target = this.element
    }

    this.usable = true
    this.height = this.element.offsetHeight
  },

  element: null,
  target: null,
  height: 0,
  isVisable: true,
  isSticky: false,
  sticky_threshhold: 0,

  updateHeight: function () {
    this.height = this.element.offsetHeight
  },

  onScrollDown: function () {
    if (!this.usable) return
    this.updateHeight()

    if (scrollTracker.position_lastScroll < this.sticky_threshhold) {
      this.makeUnsticky()
      this.isSticky = false
      return
    }

    if (!this.isSticky) {
      this.makeSticky()
      this.isSticky = true
    }

    if (this.isVisable && scrollTracker.ScrollDistance() > minScrollDown()) {
      this.makeInvisible()
      this.isVisable = false
    }
  },

  onScrollUp: function () {
    if (!this.usable) return

    if (scrollTracker.position_lastScroll < this.sticky_threshhold && !this.isVisable) {
      this.makeUnsticky()
      this.makeVisible()
      this.isVisable = true
      this.isSticky = false
      return
    }

    if (!this.isVisable && scrollTracker.ScrollDistance() > minScrollUp()) {
      this.makeVisible()
      this.isVisable = true
    }
  },
  makeVisible: function () {},
  makeInvisible: function () {},
  makeSticky: function () {},
  makeUnsticky: function () {},
}

////////// Header //////////
var header = document.getElementById("shopify-section-header")
var headerHeight = header.offsetHeight

////////// Announcement Bar //////////
let announcementBar = Object.create(StickyHeaderElement)
announcementBar.init("#shopify-section-announcement-bar-moving", "#shopify-section-header")
announcementBar.makeVisible = function () {
  this.target.style.top = this.height + "px"
}
announcementBar.makeInvisible = function () {
  this.target.style.top = "0"
}
if (announcementBar.usable) {
  announcementBar.element.style.position = "sticky"
  announcementBar.element.style.top = "0"
  announcementBar.element.style.zIndex = "5"
  header.style.transition = "top 0.3s"
}

////////// Swiper //////////
let swiperHeader = Object.create(StickyHeaderElement)
swiperHeader.init(".Main-Collection__swiper-wrapper")
swiperHeader.makeSticky = function () {
  this.target.style.top = headerHeight + announcementBar.height + "px"
  this.target.style.transition = "none"
  setTimeout(() => {
    this.target.style.transition = "transform 0.3s"
  }, 200)
}
swiperHeader.makeUnsticky = function () {
  this.target.style.top = "unset"
}
swiperHeader.makeVisible = function () {
  this.target.style.transform = "translateY(0px)"
}
swiperHeader.makeInvisible = function () {
  this.target.style.transform = "translateY(-" + (this.height + announcementBar.height) + "px)"
}
if (swiperHeader.usable) {
  swiperHeader.sticky_threshhold = swiperHeader.target.offsetTop + swiperHeader.height
}

////////// Scroll Event //////////
window.addEventListener("scroll", (event) => {
  scrollTracker.Update(window.scrollY)
  if (scrollTracker.isScrollUp) {
    announcementBar.onScrollUp()
    swiperHeader.onScrollUp()
  } else {
    announcementBar.onScrollDown()
    swiperHeader.onScrollDown()
  }
})
